import api from "../index";
import { apiUrl } from "../../utils/constants";

export const GetTasks = (params) => api.get(apiUrl.tasks, { params });
export const GetSingleTask = (id) => api.get(`${apiUrl.tasks}/${id}`);
export const DeleteSingleTask = (id) => api.delete(`${apiUrl.tasks}/${id}`);
export const CreateTask = (data) => api.post(apiUrl.tasks, data);
export const UpdateTask = (id, data) => api.put(`${apiUrl.tasks}/${id}`, data);
export const SendTaskReminders = (id) =>
  api.post(`${apiUrl.tasks}/${id}/send-reminders`);
